import _ from "lodash";
import { graphql } from "lib/apolloClient";
import {
  SNPv2_ACCESS_PERMISSION,
  SNPv2_VISITOR_PORTAL_PERM_GROUP,
} from "Constants/permissionConstants";
import ACLStore from "lib/aclStore";
import { getSnPEvaluationCyclesBasicDetailsQuery } from "../SnPQueries";
import { getSnPEvaluationCyclesBasicDetailsFromCache } from "../SnPGraphqlHelpers";
import { getSnpV2Cycles } from "../SnPUtils";
import { getFilteredUserCurriculumProgramIds } from "Platform/modules/PlatformUtils";

const queryConfig = {
  name: "getSnPEvaluationCycles",
  alias: "getSnPEvaluationCycles",
  skip: ({
    curriculumProgramId,
    isUserInToddleLibrary = false,
    curriculumProgramIds = [],
    shouldSkipSnPEvaluationCyclesQuery = false,
  }) => {
    if (shouldSkipSnPEvaluationCyclesQuery) return true;

    const isVisitor = ACLStore.can(SNPv2_VISITOR_PORTAL_PERM_GROUP);

    if (isVisitor) return true;

    if (isUserInToddleLibrary) return true;

    const enabledIds = getFilteredUserCurriculumProgramIds({
      module: SNPv2_ACCESS_PERMISSION,
      curriculumProgramIds: !_.isEmpty(curriculumProgramIds)
        ? curriculumProgramIds
        : [curriculumProgramId],
    });

    return enabledIds.length === 0;
  },
  options: ({
    organizationId,
    curriculumProgramId,
    curriculumProgramIds = [],
  }) => {
    const enabledIds = getFilteredUserCurriculumProgramIds({
      module: SNPv2_ACCESS_PERMISSION,
      curriculumProgramIds: !_.isEmpty(curriculumProgramIds)
        ? curriculumProgramIds
        : [curriculumProgramId],
    });
    return {
      fetchPolicy: "cache-and-network",
      variables: {
        id: organizationId,
        filters: {
          isArchived: false,
          curriculumProgramId: enabledIds,
        },
      },
    };
  },
  props({
    getSnPEvaluationCycles,
    ownProps: {
      isLoading = false,
      isData = true,
      showLoader,
      isSinglePageAndNewUnitViewEnabled = false,
    },
  }) {
    const variables = _.get(getSnPEvaluationCycles, "variables", {});
    const organizationData = getSnPEvaluationCyclesBasicDetailsFromCache(
      variables
    );
    const cycles = _.get(organizationData, "snpEvaluationCycles", []);

    const newSnpCycles = getSnpV2Cycles({ cycles });

    const totalNewSnpCycles = _.size(newSnpCycles);

    return {
      isData: isSinglePageAndNewUnitViewEnabled
        ? isData
        : !_.isEmpty(organizationData) && isData,
      totalNewSnpCycles,
      isLoading: isSinglePageAndNewUnitViewEnabled
        ? isLoading
        : getSnPEvaluationCycles["networkStatus"] == 1 ||
          getSnPEvaluationCycles["networkStatus"] == 2 ||
          isLoading,
      showLoader: !isSinglePageAndNewUnitViewEnabled
        ? showLoader
        : getSnPEvaluationCycles["networkStatus"] == 1 ||
          getSnPEvaluationCycles["networkStatus"] == 2 ||
          showLoader,
    };
  },
};

export default graphql(getSnPEvaluationCyclesBasicDetailsQuery, queryConfig);
